import React from "react";
import { connect as reduxConnect } from "react-redux";

export function connect<T extends React.ComponentClass<{}>>(
  mapStateToProps: any,
  mapDispatchToProps: any
) {
  return (target: any) => {
    return reduxConnect(mapStateToProps, mapDispatchToProps)(target);
  };
}
